import { SVGChevronDown } from "@/lib/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.laptop} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Indicator = styled(SVGChevronDown)<{ $menuIsOpen?: boolean }>`
  width: 1rem;
  transform: ${({ $menuIsOpen }) => ($menuIsOpen ? "rotate(180deg)" : "none")};
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 3.75rem;
  }
`;

export const Content = styled.div`
  order: 3;
  ${({ theme }) => theme.mediaQueries.laptop} {
    order: 2;
    display: flex;
    align-items: center;
    align-self: stretch;
  }
`;

export const Control = styled.div`
  font-size: 4rem;
  font-weight: 400;
  line-height: 0.9;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  user-select: none;
  display: flex;
  gap: 1rem;

  order: 1;
  ${({ theme }) => theme.mediaQueries.laptop} {
    font-size: 7.5rem;
    gap: 2rem;
  }
`;

export const Menu = styled.div`
  height: 0;
  overflow: hidden;
  order: 2;
  ${({ theme }) => theme.mediaQueries.laptop} {
    flex: 1 0 100%;
    order: 3;
  }
`;

export const MenuItem = styled.div`
  font-size: 4rem;
  font-weight: 400;
  line-height: 0.9;
  color: ${({ theme }) => theme.colors.middleGrey};
  padding-top: 1rem;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.red};
  }
  transition: color 0.3s;
  display: block;
  text-decoration: none;

  ${({ theme }) => theme.mediaQueries.laptop} {
    font-size: 7.5rem;
  }
`;
